import { Component, type OnInit } from "@angular/core"
import { Router } from "@angular/router"

@Component({
  selector: "app-maintenance-page",
  templateUrl: "./maintenance-page.component.html",
  styleUrls: ["./maintenance-page.component.css"],
})
export class MaintenancePageComponent implements OnInit {
  currentYear: number = new Date().getFullYear()

  constructor(private router: Router) {}

  ngOnInit(): void {}

  navigateBack() {
    this.router.navigate(['/login']);
  }
}